<script>
import Undo from "../../undo/undo.js";
import { mapGetters } from "vuex";

export default {
  name: "subtitleUndoRedo",
  data () {
    return {
      canUndo: false,
      canRedo: false,
      stack: null,
      editCommand: null
    };
  },
  computed: {
    ...mapGetters({
      subtitles: "subtitle/subtitles"
    })
  },
  methods: {
    insertStack (data) {
      this.stack.execute(
        new this.editCommand(data.type, data.data, this.executeFunc)
      );
      this.checkCanUndoRedo();
    },
    executeFunc (commandName, type, data) {
      this[commandName + "_" + type](data);
      this.$bus.emit("subtitle_undoRodo_execute", {
        mod: commandName,
        type: type
      });
    },
    undo () {
      this.stack.undo();
      this.checkCanUndoRedo();
    },
    redo () {
      this.stack.redo();
      this.checkCanUndoRedo();
    },
    checkCanUndoRedo () {
      this.canUndo = this.stack.canUndo();
      this.canRedo = this.stack.canRedo();
    },
    updateSubtitle_time_undo (data) {
      this.$store.commit("subtitle/updateSubtitle", {
        subtitle: data.reData,
        index: data.index
      });
    },
    updateSubtitle_time_redo (data) {
      this.$store.commit("subtitle/updateSubtitle", {
        subtitle: data.data,
        index: data.index
      });
    },
    addSubtitles_time_undo (data) {
      let index = -1;
      if (data.index > -1 && data.index < this.subtitles.length) {
        index = data.index;
      } else {
        index = this.subtitles.length - 1;
      }

      this.$store.commit("subtitle/delSubtitles", index);
    },
    addSubtitles_time_redo (data) {
      this.$store.commit("subtitle/addSubtitles", {
        index: data.index,
        subtitle: JSON.parse(data.data)
      });
    },
    delSubtitles_undo(data) {
      this.$store.commit("subtitle/addSubtitles", {
        index: data.index,
        subtitle: JSON.parse(data.data)
      });
    },
    delSubtitles_redo(data) {
      this.$store.commit("subtitle/delSubtitles", data.index);
    },
    swapSubtitles_time_undo (data) {
      this.$store.commit("subtitle/clearSubtitles");
      this.$store.commit("subtitle/addGroupSubtitles", {
        subtitles: JSON.parse(data.reData)
      });
    },
    swapSubtitles_time_redo (data) {
      this.$store.commit("subtitle/clearSubtitles");
      this.$store.commit("subtitle/addGroupSubtitles", {
        subtitles: JSON.parse(data.data)
      });
    },
    subtitleApplyAll_undo (data) {
      this.subtitles.forEach((v, i) => {
        this.$store.commit('subtitle/updateSubtitle', {
          subtitle: data.reData[i],
          index: i
        });
      });
    },
    subtitleApplyAll_redo (data) {
      this.subtitles.forEach((v, i) => {
        this.$store.commit('subtitle/updateSubtitle', {
          subtitle: data.data,
          index: i
        });
      });
    },
    updateDubbingGroup_undo (data) {
      let d = JSON.parse(data.data);
      let r = JSON.parse(data.reData);
      this.$store.commit("addSoundtrack/addDubbingGroup", {
        dubbings: r,
        index: data.index,
        delNum: d.length
      });
      this.$store.commit('addSoundtrack/setDubbingIndex', data.index);
    },
    updateDubbingGroup_redo (data) {
      let d = JSON.parse(data.data);
      let r = JSON.parse(data.reData);
      this.$store.commit("addSoundtrack/addDubbingGroup", {
        dubbings: d,
        index: data.index,
        delNum: r.length
      });
      this.$store.commit('addSoundtrack/setDubbingIndex', data.index);
    },
    updateDubbing_undo(data) {
      // if (data.data.length && data.reData.length) {
      //   this.$store.commit("addSoundtrack/addDubbingGroup", {
      //     dubbing: JSON.parse(data.reData),
      //     index: data.index,
      //     delNum: data.data.length
      //   });
      //   return;
      // }
      this.$store.commit("addSoundtrack/updateDubbing", {
        dubbing: JSON.parse(data.reData),
        index: data.index
      });
    },
    updateDubbing_redo(data) {
      // if (data.data.length && data.reData.length) {
      //   this.$store.commit("addSoundtrack/addDubbingGroup", {
      //     dubbing: JSON.parse(data.data),
      //     index: data.index,
      //     delNum: data.reData.length
      //   });
      //   return;
      // }
      this.$store.commit("addSoundtrack/updateDubbing", {
        dubbing: JSON.parse(data.data),
        index: data.index
      });
    },
    
    replaceMusic_undo(data) {
      this.$store.commit("addSoundtrack/updateMusic", {
        music: data.reData,
        index: data.index
      });
      if (data.type === 'Cancel') {
        this.$store.commit('addSoundtrack/setLoopSoundtrackStatus', true);
      }
    },
    replaceMusic_redo(data) {
      this.$store.commit("addSoundtrack/updateMusic", {
        music: data.data,
        index: data.index
      });
      if (data.type === 'Cancel') {
        this.$store.commit('addSoundtrack/setLoopSoundtrackStatus', false);
      }
    },

    updateMusic_undo(data) {
      this.$store.commit("addSoundtrack/updateMusic", {
        music: JSON.parse(data.reData),
        index: data.index
      });
    },
    updateMusic_redo(data) {
      this.$store.commit("addSoundtrack/updateMusic", {
        music: JSON.parse(data.data),
        index: data.index
      });
    },
    loopMusic_undo(data) {
      this.$store.commit("addSoundtrack/setLoopUndoRedo", {
        musics: data.oldMusics,
        action: 'loop',
        type: 'undo'
      });
    },
    loopMusic_redo (data) {
        this.$store.commit("addSoundtrack/setLoopUndoRedo", {
        musics: data.musics,
        action: 'loop',
        type: 'redo'
      });
    },
    clearSoundTracks_undo () {
      this.$store.commit('addSoundtrack/clearSound', 'music');
    },
    clearSoundTracks_redo (data) {
      this.$store.commit("addSoundtrack/setLoopUndoRedo", {
        musics: data.musics,
        type: 'redo'
      });
    },
    addMusic_undo (data) {
      this.$store.commit("addSoundtrack/delMusic", data.index);
    },
    addMusic_redo (data) {
      this.$store.commit("addSoundtrack/addMusic", {
        index: data.index,
        music: JSON.parse(data.data)
      });
    },
    addDubbing_undo (data) {
      this.$store.commit("addSoundtrack/delDubbing", data.index);
    },
    addDubbing_redo (data) {
      this.$store.commit("addSoundtrack/addDubbing", {
        index: data.index,
        dubbing: JSON.parse(data.data)
      });
    },
    delDubbing_undo(data) {
      this.$store.commit("addSoundtrack/addDubbing", {
        index: data.index,
        dubbing: JSON.parse(data.data)
      });
    },
    delDubbing_redo(data) {
      this.$store.commit("addSoundtrack/delDubbing", data.index);
    },
    delMusic_undo(data) {
      if(data.loopStatus === 'loop') {
          this.$store.commit("addSoundtrack/setLoopSoundtrackStatus", true);
      }
      this.$store.commit("addSoundtrack/addMusic", {
        index: data.index,
        music: JSON.parse(data.data)
      });
    },
    delMusic_redo(data) {
      if(data.loopStatus === 'loop') {
          this.$store.commit("addSoundtrack/setLoopSoundtrackStatus", false);
      }
      this.$store.commit("addSoundtrack/delMusic", data.index);
    },
    changeVolume_undo(data) {
      this.$store.commit("addSoundtrack/changeVolume", {
        type: data.volumeType,
        volume: data.reData
      });
    },
    changeVolume_redo(data) {
      this.$store.commit("addSoundtrack/changeVolume", {
        type: data.volumeType,
        volume: data.data
      });
    }
  },
  mounted () {
    this.$bus.on("insert_subtitle_undo", this.insertStack);
    this.$bus.on("subtitle_keycode_undo", ({ type }) => {
      if (type == "undo") {
        this.undo();
      } else if (type == "redo") {
        this.redo();
      }
    });

    this.stack = new Undo.Stack();
    this.editCommand = Undo.Command.extend({
      constructor: function (commandName, data, executeFunc) {
        this.commandName = commandName;
        this.data = data;
        this.executeFunc = executeFunc;
      },
      execute: function () { },
      undo: function () {
        this.executeFunc(this.commandName, "undo", this.data);
      },
      redo: function () {
        this.executeFunc(this.commandName, "redo", this.data);
      }
    });
  },
  beforeDestroy () {
    this.$bus.$off("insert_subtitle_undo");
    this.$bus.$off("subtitle_keycode_undo");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleUndoRedo.vue